export const LOAD_REPORTS_REQUEST = 'LOAD_REPORTS_REQUEST'
export const LOAD_REPORTS_SUCCESS = 'LOAD_REPORTS_SUCCESS'
export const LOAD_REPORTS_FAILURE = 'LOAD_REPORTS_FAILURE'
export const SET_ACTIVE_REPORT = 'SET_ACTIVE_REPORT'
